import React, { useRef, useEffect } from 'react';
import * as d3 from 'd3';
import Home from './home.svg'
import DataPackageImage from './data-package-filled.svg'

interface NodeData {
  title: string;
  children?: NodeData[][];
}

const data: NodeData[] = [
  { title: "Home",
    children:[
        [
            {
                title: "Welcome to our website"
            }
        ]
    ]
   },
  {
    title: "Locations",
    children: [
      [
        {
          title: 'Business Intelligence & Data Warehouse',
          children: [
            [
              { title: 'Big Data' },
              { title: 'Data Management' },
              { title: 'Security Solutions' },
            ]
          ]
        },
        {
          title: 'Business Planning & Consolidation',
          children: [
            [
              { title: 'Customer Relationship Management' },
              { title: 'Human Capital Management' },
              { title: 'Service Oriented Architecture' },
              { title: 'Supply Chain Management' },
            ]
          ]
        },
        { title: 'E-Business Suite' },
        {
          title: 'Enterprise Solutions',
          children: [
            [
              { title: 'Enterprise Content Management' },
              { title: 'Enterprise Portal & Collaboration' },
              { title: 'Enterprise Resource Planning' },
            ]
          ]
        },
        { title: 'SAP Sustainability Solution' },
      ],
      [
        {
            title: "Welcome to our website",
            children:[
                [
                    {
                        title: "Welcome to Group 1",
                        children:[
                            [
                                {
                                    title:"Welcome to Group 1.1"
                                }
                            ],
                            [
                                {
                                    title:"Welcome to Group 2.1"
                                }
                            ]
                        ]
                    },
                    {
                        title: "Welcome to Group 2"
                    }
                ]
            ]
        }
    ],
    [
        {
            title: "Welcome group 3.1",
            children:[
                [
                    {
                        title:"Welcome to Group 3.1.1"
                    },
                    {
                     title: "Welcome to Group 3.1.2"
                    },
                    {
                        title: "Welcome to Group 3.1.3"
                       },
                ]
            ]
        }
    ],
    [
        {
            title: "Welcome group 3.2"
        }
    ]
    ]
  },
  { title: "Centers of Excellence",
    children:[
        [
            {
                title: "Welcome to our website"
            }
        ]
    ]
   },
 
];

const Timeline: React.FC = () => {
    const svgRef = useRef<SVGSVGElement | null>(null);
    const width = 2000;
    const height = 800;

    useEffect(() => {
        const svg = d3.select(svgRef.current);
        svg.selectAll('*').remove();
        const g = svg.append('g').attr('transform', 'translate(30, 30)');

        const verticalSpacing = 25;
        const childIndent = 15;
        const imageSize = 10;
        const nodePadding = 1;

        const totalAvailableWidth = width - 60;

        const calculateNodeWidth = (title: string) => {
            const baseWidth = title.length * 4;
            return baseWidth + 0.5;
        };

        const calculateTotalWidth = (node: NodeData, depth: number = 1): number => {
            const nodeWidth = calculateNodeWidth(node.title);
            if (!node.children || node.children.length === 0) {
                return nodeWidth;
            }

            const childrenWidths = node.children.map((childGroup) => 
                d3.max(childGroup.map((child) => calculateTotalWidth(child, depth + 1))) || 0
            );
            const maxChildrenWidth = d3.sum(childrenWidths) + (node.children.length - 1) * childIndent;

            return Math.max(nodeWidth, maxChildrenWidth);
        };

        const calculateGroupWidth = (group: NodeData[]): number => {
            return d3.max(group.map(node => node.title.length * 6)) || 0;
        };

        // Calculate the total width needed for all root nodes
        const rootWidths = data.map(rootNode => calculateTotalWidth(rootNode));
        const totalRootWidth = d3.sum(rootWidths);

        // Calculate the spacing between root nodes
        const rootSpacing = (totalAvailableWidth - totalRootWidth) / (data.length - 1) * .7;

        let currentXPosition = 0;
        let maxXPosition = 0;
        const rootXPositions: number[] = [];

        const renderChildren = (
            parentGroup: d3.Selection<SVGGElement, unknown, null, undefined>,
            children: NodeData[][],
            depth: number = 1,
            parentY: number = 0
        ) => {
            let maxHeight = verticalSpacing;
            if (depth === 1) maxHeight += 30;
            let previousGroupBentLength = 0;
            let extraXSpace = 0;
            

            children.forEach((childGroup, groupIndex) => {
                let groupMaxWidth = 0;

                childGroup.forEach((child, childIndex) => {
                    const childNodeGroup = parentGroup
                        .append('g')
                        .attr('transform', `translate(${maxXPosition}, ${maxHeight})`);
                        

                    childNodeGroup
                        .append('circle')
                        .attr('r', 10)
                        .attr('cx', 0)
                        .attr('cy', 0)
                        .style('stroke', '#D9D9D9')
                        .style('fill', '#ffff');

                    childNodeGroup
                        .append('image')
                        .attr('xlink:href', DataPackageImage)
                        .attr('x', -5)
                        .attr('y', -5)
                        .attr('width', imageSize)
                        .attr('height', imageSize);

                    const textNode = childNodeGroup
                        .append('text')
                        .attr('dy', '0.32em')
                        .attr('x', child.children ? 30 : 15)
                        .attr('y', 0)
                        .style('text-anchor', 'start')
                        .text(child.title)
                        .style('font-size', `${12 - depth}px`)
                        .style('fill', '#333')
                        .style('font-weight', child.children ? 'bold' : 'normal');

                    const textWidth = (textNode.node() as SVGTextElement).getComputedTextLength();
                    groupMaxWidth = Math.max(groupMaxWidth, textWidth + (child.children ? 25 : 15) + nodePadding);

                    // if ( childIndex < childGroup.length - 1) {
                        parentGroup
                            .append('line')
                            .attr('x1', 0)
                            .attr('y1', 0)
                            .attr('x2', 0)
                            .attr('y2', maxHeight)
                            .style('stroke', '#6BAED6')
                            .style('stroke-width', 1);
                    // }

                    if (groupIndex > 0) {
                        const groupTotalWidth = calculateGroupWidth(childGroup);
                        const horizontalLength = (maxXPosition==0 ? textWidth : maxXPosition*2)+Math.max(textWidth,childIndent);

                        parentGroup
                            .append('line')
                            .attr('x1', 0)
                            .attr('y1', parentY)
                            .attr('x2', horizontalLength)
                            .attr('y2', parentY)
                            .style('stroke', '#6BAED6')
                            .style('stroke-width', 1);

                        parentGroup
                            .append('line')
                            .attr('x1', horizontalLength)
                            .attr('y1', parentY)
                            .attr('x2', horizontalLength)
                            .attr('y2', parentY + verticalSpacing)
                            .style('stroke', '#6BAED6')
                            .style('stroke-width', 1);

                        childNodeGroup.attr(
                            'transform',
                            `translate(${horizontalLength}, ${parentY + verticalSpacing})`
                        );

                        previousGroupBentLength += horizontalLength;
                        extraXSpace = Math.max(extraXSpace, groupTotalWidth);
                    } else {
                        previousGroupBentLength = groupMaxWidth;
                        childNodeGroup.attr('transform', `translate(${0}, ${maxHeight})`);
                    }

                    if (child.children) {
                        const bentLineGroup = childNodeGroup
                            .append('g')
                            .attr('transform', `translate(${childIndent}, 0)`);

                        bentLineGroup
                            .append('line')
                            .attr('x1', 0)
                            .attr('y1', 0)
                            .attr('x2', -childIndent)
                            .attr('y2', 0)
                            .style('stroke', '#6BAED6')
                            .style('stroke-width', 1);

                        bentLineGroup
                            .append('line')
                            .attr('x1', -childIndent)
                            .attr('y1', 0)
                            .attr('x2', -childIndent)
                            .attr('y2', verticalSpacing)
                            .style('stroke', '#6BAED6')
                            .style('stroke-width', 1);

                        const childHeight = renderChildren(bentLineGroup, child.children, depth + 1);
                        maxHeight += childHeight;
                    } else {
                        maxHeight += verticalSpacing;
                    }
                });
            
                maxXPosition += extraXSpace;
            });

            return maxHeight;
        };

        data.forEach((rootNode, index) => {
            const rootTotalWidth = rootWidths[index];
            
            const rootGroup = g
                .append('g')
                .attr('transform', `translate(${currentXPosition+rootNode.title.length*2}, 0)`);

            rootGroup
                .append('circle')
                .attr('r', 10)
                .attr('cx', 0)
                .attr('cy', 0)
                .style('fill', '#393939');

            rootGroup
                .append('image')
                .attr('xlink:href', Home)
                .attr('x', -imageSize / 2)
                .attr('y', -imageSize / 2)
                .attr('width', imageSize)
                .attr('height', imageSize);

            const titleYPosition = imageSize / 2 + verticalSpacing;
            rootGroup
                .append('text')
                .attr('dy', '1.5em')
                .attr('x', 0)
                .attr('y', 0)
                .style('text-anchor', 'middle')
                .text(rootNode.title)
                .style('font-size', '15px')
                .style('fill', '#333333')
                .style('font-weight', 'bold');

            rootXPositions.push(currentXPosition+rootNode.title.length*2);
            if (rootNode.children)
                rootGroup
                    .append('line')
                    .attr('x1', 0)
                    .attr('y1', titleYPosition)
                    .attr('x2', 0)
                    .attr('y2', titleYPosition + verticalSpacing)
                    .style('stroke', '#6BAED6')
                    .style('stroke-width', 1);

            if (rootNode.children) {
                const childGroup = rootGroup.append('g').attr('transform', `translate(0, ${titleYPosition + verticalSpacing})`);
                renderChildren(childGroup, rootNode.children);
            }

            currentXPosition += rootTotalWidth+rootSpacing;
        });

        if (rootXPositions.length > 1) {
            g.append('line')
                .attr('x1', rootXPositions[0])
                .attr('y1', imageSize / 2)
                .attr('x2', rootXPositions[rootXPositions.length - 1])
                .attr('y2', imageSize / 2)
                .style('stroke', '#6BAED6')
                .style('stroke-width', 1);
        }
    }, [data]);

    return (
        <div style={{ width: '100%', height: '100%', overflow: 'visible' }}>
            <svg ref={svgRef} width={width} height={height}></svg>
        </div>
    );
};

  
  
  


export default Timeline;
